import {
  ELaForgeWorkerEnum,
  EWorkerVerificationIDType,
  ZealApiResponse,
} from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const getWorkerIds = (axios: IAxiosInstance) => {
  return async (params: {
    companyID: string;
    workerID: string;
    idTypes: string[];
  }) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<
        {
          id_type: EWorkerVerificationIDType;
          url: string;
          personaInquiryId: string;
          worker_type: ELaForgeWorkerEnum;
        }[]
      >
    >("/api/getWorkerIds", {
      params,
      withCredentials: true,
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
